import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { ToastService } from '../../services/toast.service';

interface LoginForm {
  password: FormControl,
  confirmPassword: FormControl,
}

@Component({
  selector: 'app-definicao-senha',
  templateUrl: './definicao-senha.component.html',
  styleUrl: './definicao-senha.component.css'
})
export class DefinicaoSenhaComponent implements OnInit {
  loginForm!: FormGroup<LoginForm>;

  email!: string
  token!: string

  constructor(private loginService: LoginService, private toastService: ToastService, private activatedRoute: ActivatedRoute, private router: Router){
    this.loginForm = new FormGroup({
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
      confirmPassword: new FormControl('', [Validators.required, Validators.minLength(6)])
    })

    
  }

  ngOnInit(){
    this.activatedRoute.queryParams.subscribe((params) => {
      this.email = params['email']
      this.token = params['identificador']
    })
  }

  submit(){
    
    if(this.loginForm.valid && this.loginForm.value.password === this.loginForm.value.confirmPassword){
      this.loginService.redefinir(this.email, this.token, this.loginForm.value.password).subscribe({
        next: () => {
          // this.messageService.add({severity: 'success', summary: 'Success', detail: 'Login realizado'})
          this.toastService.sucesso('Sucesso', 'Senha alterada!')
          
          this.router.navigate(["login"])
        },
        error: (value) => {
          this.toastService.erro('Erro', value.error)
          // this.messageService.add({severity: 'error', summary: 'Erro', detail: value.error })
        }
      })
    }
    
  }
}
